export default "__VITE_ASSET__9825ed32__"